import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auth-verify-email',
  templateUrl: './auth-verify-email.component.html',
  styleUrls: ['./auth-verify-email.component.scss']
})
export class AuthVerifyEmailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
